import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AuthHandler from "../../services/common/auth-handler";

const authHandler = AuthHandler();

const UnauthorizedPage = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(authHandler.getLanguage());
    }, [i18n])

    return (
        <div className="height-100 d-flex flex-column justify-content-center align-items-center">
            <img
                alt="unauthorized"
                src={`${process.env.PUBLIC_URL}/images/unauthorized.svg`} />
            <h1 className="c-dark-blue fw-semi-bold">{t("unauthorized")}</h1>
            <div className="text-center w-75">
                <span className="c-dark-blue">
                    {t("unauthorized_content")}
                </span>
            </div>
        </div>);
}

export default UnauthorizedPage;